//@flow
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import CrmCampaignSummary from './crm-campaign-summary';
import CrmCampaignForm from './crm-campaign-form';
import CampaignDetail from './campaign-detail';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
}));

export default function CrmCampaigns() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Switch>
        <Route exact path="/campaigns" component={CrmCampaignSummary}></Route>
        <Route path="/campaigns/:id" component={CrmCampaignForm}></Route>
        <Route path="/campaigns/detail/:id" component={CampaignDetail}></Route>
      </Switch>
    </div>
  );
}
